/**
 * Do not edit directly
 * Generated on Thu, 29 Sep 2022 18:15:25 GMT
 */

export const componentOverlayCloseButtonHeight = "2.5rem";
export const componentOverlayCloseButtonIconColor = "#000";
export const componentOverlayCloseButtonIconName = "Close";
export const componentOverlayCloseButtonIconSize = "medium";
export const componentOverlayCloseButtonWidth = "2.5rem";
export const componentOverlayContainerZIndex = "500";
export const componentOverlayScrimBackgroundColor = "rgba(0, 0, 0, 0.4)";
export const componentOverlayScrimStateEnterOpacity = 0;
export const componentOverlayScrimStateEnterActiveOpacity = 1;
export const componentOverlayScrimStateExitOpacity = 1;
export const componentOverlayScrimStateExitActiveOpacity = 0;